import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import Dialog from 'global/guides/Dialog'
import { Trash2Icon } from 'lucide-react'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { centroCustoFuncionario_api, funcionario } from 'service/api'
import { toast } from 'sonner'

export const FucionarioCentroCustoExluir: React.FC<GridCellParams> = ({
    row,
}) => {
    const { pathname } = useLocation()
    const [open, setOpen] = React.useState(false)

    const toggle = () => setOpen(state => !state)

    const { mutateAsync, isLoading } =
        centroCustoFuncionario_api.mutations.useDelete()

    const handleSubmit = () => {
        mutateAsync(row.id, {
            onSuccess: async () => {
                toast.success('Centro de custo excluído com sucesso')

                await Promise.all([
                    centroCustoFuncionario_api.invalidateQueries(),
                    funcionario.invalidateQueries(),
                ])

                toggle()
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <div>
            <IconButton
                onClick={toggle}
                disabled={pathname.endsWith('detalhes')}
            >
                <Trash2Icon className="text-error" />
            </IconButton>

            <Dialog.Root
                open={open}
                onClose={toggle}
                onSubmit={
                    !pathname.endsWith('detalhes') ? handleSubmit : undefined
                }
                loading={isLoading}
            >
                <Dialog.Title wrap>
                    Deseja realmente excluir este centro de custo?
                </Dialog.Title>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                    <Dialog.Actions.PrimaryButton color="error">
                        Excluir
                    </Dialog.Actions.PrimaryButton>
                </Dialog.Actions>
            </Dialog.Root>
        </div>
    )
}
